// categoryService.js
import api from './api';
import { API_ENDPOINTS } from '../utils/constants';

export const categoryService = {
  // Get all categories with product count
  getAll: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.CATEGORIES);
      // If the API doesn't return products count, fetch it separately
      const categories = response.data;
      
      // Option 1: If API returns products with categories
      if (categories && categories.length > 0 && categories[0].products) {
        return categories;
      }
      
      // Option 2: Fetch product counts separately (if needed)
      // const productsResponse = await api.get(API_ENDPOINTS.PRODUCTS);
      // const products = productsResponse.data;
      // categories.forEach(category => {
      //   category.products = products.filter(p => p.category_id === category.id);
      // });
      
      return categories;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // Get single category
  getById: async (id) => {
    try {
      const response = await api.get(API_ENDPOINTS.CATEGORY_DETAIL(id));
      return response.data;
    } catch (error) {
      console.error(`Error fetching category ${id}:`, error);
      throw error;
    }
  },

  // Create category
  create: async (data) => {
    try {
      const response = await api.post(API_ENDPOINTS.CATEGORIES, data);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  // Update category
  update: async (id, data) => {
    try {
      const response = await api.put(API_ENDPOINTS.CATEGORY_DETAIL(id), data);
      return response.data;
    } catch (error) {
      console.error(`Error updating category ${id}:`, error);
      throw error;
    }
  },

  // Delete category
  delete: async (id) => {
    try {
      const response = await api.delete(API_ENDPOINTS.CATEGORY_DETAIL(id));
      return response.data;
    } catch (error) {
      console.error(`Error deleting category ${id}:`, error);
      throw error;
    }
  },
};